import pvTodayGen from '@/assets/SituationRoom_scss/src/right_icon/pv_today_gen.svg'
import pvMonthGen from '@/assets/SituationRoom_scss/src/right_icon/pv_month_gen.svg'
import pvYearGen from '@/assets/SituationRoom_scss/src/right_icon/pv_year_gen.svg'
import pvYearRed from '@/assets/SituationRoom_scss/src/right_icon/pv_year_red.svg'
import loadTodayCons from '@/assets/SituationRoom_scss/src/right_icon/load_today_cons.svg'
import loadMonthCons from '@/assets/SituationRoom_scss/src/right_icon/load_month_cons.svg'
import loadYearCons from '@/assets/SituationRoom_scss/src/right_icon/load_year_cons.svg'
import loadYearEmi from '@/assets/SituationRoom_scss/src/right_icon/load_year_emi.svg'
import bessChgPower from '@/assets/SituationRoom_scss/src/right_icon/bess_chg_power.svg'
import bessDisPower from '@/assets/SituationRoom_scss/src/right_icon/bess_dis_power.svg'
import bessCapTotal from '@/assets/SituationRoom_scss/src/right_icon/bess_cap_total.svg'
import bessFeederCap from '@/assets/SituationRoom_scss/src/right_icon/bess_feeder_cap.svg'

// 輪播設定
export const IDLE_SECONDS_MIN = 30 // <-> 至少要 30 秒
export const INTERVAL_SECONDS_MIN = 20 // <-> 至少要 20 秒, 滑鼠移動需時間
export const SECONDS_MAX = 60 * 60 * 24 // 一天 (setInterval, setTimeout 有上限, 超過變為 1)
export const defaultAutoDemoSettings = {
  openDemo: true,
  idleSeconds: 60, // 偵測使用者閒置秒數
  intervalSeconds: 30, // 輪播間隔
  siteIds: [
    'f177',
    'f005',
    'f263',
    'f046',
    'f093',
    'e001',
    'field005',
    'field006',
    'field007'
  ]
}

const defaultValue = '-'

export const statsList = {
  solarInfo: {
    todayEnergy: {
      icon: pvTodayGen,
      title: '今日總發電量',
      value: 0,
      unit: 'kWh'
    },
    monthEnergy: {
      icon: pvMonthGen,
      title: '本月總發電量',
      value: 0,
      unit: 'MWh'
    },
    yearEnergy: {
      icon: pvYearGen,
      title: '今年總發電量',
      value: 0,
      unit: 'MWh'
    },
    carbonReductionSum: {
      icon: pvYearRed,
      title: '今年總減碳量',
      value: 0,
      unit: 'tCO₂e'
    }
  },

  mysqlInfo: {
    totalChargePower: {
      icon: bessChgPower,
      title: '總充電功率',
      value: 0,
      unit: 'kWh'
    },
    totalDischargePower: {
      icon: bessDisPower,
      title: '總放電功率',
      value: 0,
      unit: 'kWh'
    },
    totalCapacity: {
      icon: bessCapTotal,
      title: '總建置容量',
      value: 0,
      unit: 'kWh'
    },
    totalFeeder: {
      icon: bessFeederCap,
      title: '總饋線容量​',
      value: 0,
      unit: 'kW'
    }
  },

  powerInfo: {
    totalDailyConsumption: {
      icon: loadTodayCons,
      title: '今日總用電​量',
      value: 0,
      unit: 'kWh'
    },
    totalMonthlyConsumption: {
      icon: loadMonthCons,
      title: '本月總用電量​',
      value: 0,
      unit: 'kWh'
    },
    totalYearlyConsumption: {
      icon: loadYearCons,
      title: '今年總用電​量',
      value: 0,
      unit: 'kWh'
    },
    totalCarbonEmissions: {
      icon: loadYearEmi,
      title: '今年總排碳量​',
      value: 0,
      unit: 'tCO₂e'
    }
  }
}

// 太陽能
export const solarCharts = [
  {
    type: 'column',
    title: '同期發電量比較',
    xAxis: { categories: [] },
    series: [
      {
        linkedTo: 'main',
        name: '前期',
        data: [],
        pointPlacement: -0.2,
        color: 'rgba(158, 159, 163, 0.5)'
      },
      { id: 'main', name: '本期', data: [] }
    ]
  },
  {
    // type: 'column',
    title: '每月發電量',
    xAxis: { categories: [] },
    series: [
      { type: 'column', name: '發電量', data: [] },
      { type: 'line', name: '累積發電量', data: [] }
    ]
  },
  {
    type: 'line',
    title: '每月減碳量',
    xAxis: { categories: [] },
    series: [{ name: '累積減碳量', data: [] }]
  },
  {
    type: 'line',
    title: '每月發電收入',
    xAxis: { categories: [] },
    series: [{ name: '累積發電收入', data: [] }]
  }
]

// 儲能
export const bmsCharts = [
  {
    type: 'scatter',
    title: '單體電壓/溫度分布',
    // xAxis: { categories: [] },
    series: [
      {
        name: '電壓/溫度',
        data: [
          [0, 0],
          [0, 0]
        ],

        // timeArr 自訂 會在 this.series.userOptions 裡面出現 (highcharts 自動存放使用者設定的資料)
        timeArr: []
      }
    ]
  },
  {
    type: 'arearange',
    title: '每月充放電比率',
    xAxis: { categories: [] },
    series: [
      {
        name: '充放電比率',
        data: [],
        zIndex: 1
        // marker: {
        //   // lineWidth: 1,
        //   radius: 3
        //   // fillColor: 'white',
        //   // lineColor: Highcharts.getOptions().colors[0]
        // }
      },
      {
        name: '充放電',
        data: [],
        type: 'arearange',
        lineWidth: 0,
        linkedTo: ':previous',
        // color: Highcharts.getOptions().colors[0],
        fillOpacity: 0.3,
        zIndex: 0,
        marker: {
          enabled: false
        },
        tooltip: {
          valueSuffix: ' kWh'
        }
      }
    ]
  },
  {
    type: 'column',
    title: '案場建置數量/容量',
    xAxis: { categories: [] },
    series: [
      {
        type: 'column',
        name: '建置數',
        data: [],
        tooltip: {
          valueDecimals: 0
        }
      },
      {
        type: 'line',
        name: '建置容量',
        data: [],
        tooltip: {
          valueSuffix: ' kWh'
          // valueDecimals: 0,
        }
      }
    ]
  },
  {
    type: 'line',
    title: '每月充放電量',
    xAxis: { categories: [] },
    series: [
      { name: '充電', data: [] },
      { name: '放電', data: [] }
    ]
  }
]

// 用電
export const powerCharts = [
  {
    type: 'column',
    title: '今日/昨日用電量',
    xAxis: { categories: [] },
    series: [
      { name: '昨日用電', data: [] },
      { name: '今日用電', data: [] }
    ]
  },
  {
    type: 'candlestick',
    title: '電量小時K線圖',
    xAxis: { categories: [] },
    series: [
      {
        name: '電量',
        data: [],
        tooltip: {
          pointFormat:
            'first: <b>{point.open} kW</b><br/>max: <b>{point.high} kW</b><br/>min: <b>{point.low} kW</b><br/>last: <b>{point.close} kW</b>'
        }
      }
    ]
  },
  {
    type: 'column',
    title: '本月用電量(日)',
    xAxis: { categories: [] },
    series: [{ name: '用電量', data: [] }]
  },
  {
    // type: 'column',
    title: '本月累積用電量(日)',
    xAxis: { categories: [] },
    // yAxis: [{ max: 123, labels: { enabled: false } }, {}], // 另一個不指定
    series: [
      {
        type: 'spline',
        name: '用電量',
        data: [],
        zIndex: 2,
        yAxis: 0,
        marker: { enabled: false }
      },
      { type: 'column', name: '累積用電量', data: [], zIndex: 1, yAxis: 1 }
    ]
  }
]

export const solarInfoBasic = {
  weather: { status: defaultValue, temp: defaultValue, unit: '°C', icon: '' },
  list: [
    { title: '目前日照強度', value: defaultValue, unit: 'w/m²' },
    { title: '今日日照量', value: defaultValue, unit: 'kWh/m²' },
    { title: '今日峰瓩值', value: defaultValue, unit: 'kWh/kWp' },
    { title: '今日PR值', value: defaultValue, unit: '%' }
  ],
  updateTime: ''
}

export const bmsInfoBasic = {
  list: [
    { title: 'SOC', value: defaultValue, unit: '%' },
    { title: '充電功率', value: defaultValue, unit: 'kWh' },
    { title: '放電功率', value: defaultValue, unit: 'kWh' },
    { title: 'BMS電壓', value: defaultValue, unit: 'kWh/kWp' },
    { title: 'BMS溫度', value: defaultValue, unit: '%' }
  ],
  status: {
    title: '通訊狀態',
    commStatus: [
      { name: 'PCS', status: defaultValue },
      { name: 'BMS', status: defaultValue },
      { name: '電表', status: defaultValue }
    ]
  },
  updateTime: ''
}

export const bmsCommStatusToText = {
  disconnected: '斷線',
  connected: '正常',
  error: '異常'
}

export const powerInfoBasic = {
  weather: { status: defaultValue, temp: defaultValue, unit: '°C', icon: '' },
  list: [
    {
      title: '即時功率',
      subItems: [
        // { name: '電表(1)', value: defaultValue, unit: 'kW' },
        // { name: '電表(2)', value: defaultValue, unit: 'kW' }
      ]
    },
    {
      title: '即時電壓',
      subItems: [
        // { name: '電表(1)', value: defaultValue, unit: 'V' },
        // { name: '電表(2)', value: defaultValue, unit: 'V' }
      ]
    },
    {
      title: '即時電流',
      subItems: [
        // { name: '電表(1)', value: defaultValue, unit: 'A' },
        // { name: '電表(2)', value: defaultValue, unit: 'A' }
      ]
    }
  ],
  updateTime: ''
}

export const solarAnalysisCharts = [
  // chart0
  {
    title: '每小時發電/日照圖',
    categories: [
      // '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00'
    ],
    acpData: [
      // 45.7, 37.0, 28.9, 17.1, 39.2, 18.9, 90.2, 78.5, 74.6, 18.7, 17.1, 16.0
    ], // kWh
    irrData: [], // kWh/m²
    prData: [], // %
    weatherData: [
      // { y: 28.5, weatherCode: 0 },
      // { y: 29.0, weatherCode: 86 },
    ] // °C
  },
  // chart1
  {
    title: '峰瓩值熱圖',
    xCats: [
      // '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00'
    ],
    yCats: [
      // 'INV1', 'INV2', 'INV3', 'INV4', 'INV5', 'INV6'
    ],
    data: []
    // data: heatPoints
  },
  // chart2
  {
    title: '每日發電/日照圖',
    categories: [],
    acpData: [],
    irrData: []
  }
]

export const bmsAnalysisCharts = []

export const powerAnalysisCharts = [
  // chart3
  {
    title: '每日電錶用電比較',
    categories: [],
    series: [
      // { name: 'meter1', data: [3, 5, 1, 13] },
      // { name: 'meter2', data: [14, 8, 8, 12] },
    ]
  },
  // chart4
  {
    title: '今日電錶功率比較',
    categories: [
      // '00:00', '00:01', '00:02'
    ],
    series: [
      // {
      //   name: 'meter1',
      //   data: [
      //     ['00:00', 8],
      //     ['00:01', 3],
      //     ['00:02', 5]
      //   ]
      // },
      // {
      //   name: 'meter2',
      //   data: [
      //     ['00:00', 5],
      //     ['00:01', 8],
      //     ['00:02', 3]
      //   ]
      // }
    ]
  },
  // chart5
  {
    title: '今日電錶功率因素',
    categories: [],
    series: [
      // { name: 'meter1', data: [] },
      // { name: 'meter2', data: [] }
    ]
  }
]
